/* eslint-disable no-sequences */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../../../../layout/content/Content";

import { Doughnut } from "react-chartjs-2";
import {
    Block,
    BlockDes,
    BlockHead,
    Col,
    Row,
    PreviewAltCard,
    Button,
    Icon,
} from "../../../../../components/Component";
import Head from "../../../../../layout/head/Head";
import DGEDashboardCountCP from "../CPDGEDashboard/DGEDashboardCountCP";
import ButtonDisableCP from "../CPDGEDashboard/ButtonDisableCP";
import SingleQuater from "../../../../components/DynmicOption/singlequarter";
import FinancialYear from "../../../../components/DynmicOption/FinancialYear";

const CPStateDashboard = ({ ...props }) => {
    const [activedata, setactivedata] = useState([])
    const [lorder, setLorder] = useState(true)
    const [selectedYear, setSelectedYear] = useState("")
    const [Selected, setSelected] = useState([])
    const [selectedOptions, setSelectedOptions] = useState([])
    const [userData, setuserData] = useState(null);
    const [Edit, setEdit] = useState({
        edit: 0,
        submit: 0,
        open: 0
    })
    const [data2, setData2] = useState({
        labels: ["Deaft", "Submitted", "Open"],
        dataUnit: "People",
        legend: false,
        datasets: [
            {
                borderColor: "#fff",
                backgroundColor: ["#f9db7b", "#1ee0ac", "#e85347",],
                data: [12, 8, 7],
            },
        ],
    })
    const tableRef = useRef(null);
    const getdata = async () => {
        const sendData = {
            CatgTypeId: Number(sessionStorage.getItem("StateCP")),

        }
        //console.log("sendData", sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetRegion', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                   // console.log("data",data)
                    setactivedata(data)
                    setLorder(false)
                })


    };

    const getdata2 = async () => {
        const sendData = {
            MonthId: Number(selectedOptions.value),
            YearId: Number(selectedYear),
            Month: sessionStorage.getItem("StateCP")
        }
        console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/Dgecountcp', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data)
                    setEdit({
                        edit: data.edit,
                        submit: data.submit,
                        open: data.open
                    })
                    setData2({
                        labels: ["Draft", "Submitted", "Open"],
                        dataUnit: "People",
                        legend: false,
                        datasets: [
                            {
                                borderColor: "#fff",
                                backgroundColor: ["#f9db7b", "#1ee0ac", "#e85347",],
                                data: [data.edit, data.submit, data.open],
                            },
                        ],
                    })
                })


    };

    const usergetdata = async () => {


        const sendData = {
            CatgTypeId: Number(sessionStorage.getItem("StateCP")),

        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Payment/Getuser2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data)
                    setuserData(data)

                })


    };

    useEffect(() => {
        usergetdata()
        getdata()
        getdata2()
        setLorder(true)
    }, [selectedOptions, selectedYear])

    return (
        <React.Fragment>
            <Head title="AllUser" />

            <Content>
                {localStorage.getItem("urole") !== "8" ?
                    <Button onClick={() => window.location.href ='/CPDGEDashboard'} style={{ marginBottom: 20 }} color='success'> <Icon name="arrow-left" />  Back To CP DGE Dashboard</Button> : null}

                <Block>

                    <BlockHead size="lg">

                        <BlockDes className="text-soft">

                            <Row className="mt-4">

                                <Col xl="3" md="3">
                                    <td >
                                        <h5 style={{ color: '#798bff' }}>CP State Dashboard</h5>
                                    </td>
                                </Col>
                                <Col xl="3" md="3">
                                    <td >
                                        <label className="form-label" htmlFor="Month">
                                            State: <label style={{ fontWeight: "bold" }}>  {userData !== null ? userData.catgType : null}</label>
                                        </label>
                                    </td>
                                </Col>
                                <Col xl="3" md="3" >
                                    <label style={{ color: 'black', fontSize: 15 }}>  Year :  <label style={{ fontWeight: 'bold' }}><FinancialYear selectedYear={selectedYear} setSelectedYear={setSelectedYear} /></label></label>

                                </Col>
                                <Col xl="3" md="3">
                                    <label style={{ color: 'black' }} >  Quarter: <label style={{ fontWeight: 'bold' }}> <SingleQuater setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} setSelected={setSelected} Selected={Selected} /></label></label>
                                </Col>
                               
                            </Row>
                            <hr />
                            <Row>
                                <Col md="4" xxl="4">
                                    <PreviewAltCard border1={true} className="h-100">
                                        <h6 className="ff-base fw-medium"><b style={{ fontSize: 20 }}>  Summary</b> :<br /><br /> <small className="text-soft">The State dashboard shows the data of employment exchange of a particular month

                                        </small></h6>
                                    </PreviewAltCard>
                                </Col>
                                <Col md="8" xxl="8">
                                    <PreviewAltCard border1={true} className="h-100">
                                        <Row>
                                            <Col md="2"></Col>
                                            <Col md="6">
                                                <div className="traffic-channel-group">

                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>
                                                            <b style={{ fontSize: 20 }}> Draft : <large style={{ marginLeft: 80 }}> {Edit.edit}</large> </b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>

                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>
                                                            <b style={{ fontSize: 20 }}> Submitted : <large style={{ marginLeft: 32 }}>{Edit.submit}</large></b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>
                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>
                                                            <b style={{ fontSize: 20 }}> Open  : <large style={{ marginLeft: 77 }}>{Edit.open}</large></b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>

                                                </div>
                                            </Col>
                                            <Col md="4">
                                                <div className="traffic-channel-doughnut-ck">
                                                    <Doughnut
                                                        className="analytics-doughnut"
                                                        data={data2}
                                                        options={{
                                                            legend: {
                                                                display: false,
                                                            },
                                                            rotation: -1.5,
                                                            cutoutPercentage: 70,
                                                            maintainAspectRatio: false,
                                                            tooltips: {
                                                                enabled: true,
                                                                backgroundColor: "#fff",
                                                                borderColor: "#eff6ff",
                                                                borderWidth: 2,
                                                                titleFontSize: 13,
                                                                titleFontColor: "#6783b8",
                                                                titleMarginBottom: 6,
                                                                bodyFontColor: "#9eaecf",
                                                                bodyFontSize: 12,
                                                                bodySpacing: 4,
                                                                yPadding: 10,
                                                                xPadding: 10,
                                                                footerMarginTop: 0,
                                                                displayColors: false,
                                                            },
                                                        }}
                                                    ></Doughnut>
                                                </div>

                                            </Col>
                                        </Row>
                                    </PreviewAltCard>

                                </Col>
                            </Row>
                        </BlockDes>


                    </BlockHead>


                    <div className="table-responsive">
                        <table className="table table-orders" ref={tableRef}>
                            <thead className="tb-odr-head">
                                <tr className="tb-odr-item" >

                                    <th >
                                       List

                                    </th>
                                    <th >
                                        No. of EEX

                                    </th>
                                    <th >
                                        Total Forms

                                    </th>
                                    <th >
                                        Open

                                    </th>
                                    <th >
                                        Draft

                                    </th>
                                    <th >
                                        Submited

                                    </th>
                                    <th >
                                        Action

                                    </th>



                                </tr>


                            </thead>
                            {lorder?null:<>
                            {activedata !== [] ? activedata.map((details) =>
                                <tr>

                                    <td> <a href="#id" onClick={() => (sessionStorage.setItem("RegionCP", details.catgTypeId), props.history.push("/CPRegionaldashboard")) } ><b style={{ fontSize: 18 }}>{details.catgType}</b>
                                    </a></td>
                                    <DGEDashboardCountCP year={selectedYear} month={selectedOptions.value} catgtype={details.catgTypeId} api={'Statecountcp'} />
                                    <ButtonDisableCP year={selectedYear} month={selectedOptions.value} catgtype={details.catgTypeId} api={'Statecountcp'} />
                                 </tr>
                            ) : null}
                            </>}




                        </table>

                    </div>




                </Block>




            </Content>

        </React.Fragment>
    );
};

export default CPStateDashboard;
